import { render, staticRenderFns } from "./UpdatePasswordDialog.vue?vue&type=template&id=22797122&scoped=true"
import script from "./UpdatePasswordDialog.vue?vue&type=script&lang=js"
export * from "./UpdatePasswordDialog.vue?vue&type=script&lang=js"
import style0 from "./UpdatePasswordDialog.vue?vue&type=style&index=0&id=22797122&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22797122",
  null
  
)

export default component.exports